export const SET_HRMS31E_INDEX_DISP = 'SET_HRMS31E_INDEX_DISP'
export const GET_HRMS31E_INDEX_DISP = 'GET_HRMS31E_INDEX_DISP'
export const SET_HRMS31E_DETAIL_DISP = 'SET_HRMS31E_DETAIL_DISP'
export const GET_HRMS31E_DETAIL_DISP = 'GET_HRMS31E_DETAIL_DISP'
export const GET_HRMS31E_MAX_ROWSPAN = 'GET_HRMS31E_MAX_ROWSPAN'
export const SET_HRMS31E_COLUMNS = 'SET_HRMS31E_COLUMNS'
export const GET_HRMS31E_COLUMNS = 'GET_HRMS31E_COLUMNS'
export const SET_HRMS31E_LABELS = 'SET_HRMS31E_LABELS'
export const GET_HRMS31E_LABELS = 'GET_HRMS31E_LABELS'
export const RECEIVED_HRMS31E_COLUMNS_LABELS = 'RECEIVED_HRMS31E_COLUMNS_LABELS'
export const SET_HRMS31E_INDEX = 'SET_HRMS31E_INDEX'
export const GET_HRMS31E_INDEX = 'GET_HRMS31E_INDEX'
export const SET_HRMS31E_INDEX_SELECTED = 'SET_HRMS31E_INDEX_SELECTED'
export const GET_HRMS31E_INDEX_SELECTED = 'GET_HRMS31E_INDEX_SELECTED'
export const RECEIVED_HRMS31E_INDEX = 'RECEIVED_HRMS31E_INDEX'
export const SET_HRMS31E_DETAIL = 'SET_HRMS31E_DETAIL'
export const GET_HRMS31E_DETAIL = 'GET_HRMS31E_DETAIL'
export const RECEIVED_HRMS31E_DETAIL = 'RECEIVED_HRMS31E_DETAIL'
export const SET_HRMS31E_DETAIL_SEARCH = 'SET_HRMS31E_DETAIL_SEARCH'
export const GET_HRMS31E_DETAIL_SEARCH = 'GET_HRMS31E_DETAIL_SEARCH'
export const RECEIVED_HRMS31E_DETAIL_SEARCH = 'RECEIVED_HRMS31E_DETAIL_SEARCH'
export const SET_HRMS31E_DETAIL_POPUP = 'SET_HRMS31E_DETAIL_POPUP'
export const GET_HRMS31E_DETAIL_POPUP = 'GET_HRMS31E_DETAIL_POPUP'
export const RECEIVED_HRMS31E_DETAIL_POPUP = 'RECEIVED_HRMS31E_DETAIL_POPUP'
export const TOGGLE_HRMS31E_PAGE = 'TOGGLE_HRMS31E_PAGE'
export const POST_HRMS31E_SAVE = 'POST_HRMS31E_SAVE'
export const POST_HRMS31E_CANCEL = 'POST_HRMS31E_CANCEL'
export const POST_HRMS31E_DELETE = 'POST_HRMS31E_DELETE'
export const POST_HRMS31E_SEND_MAIL = 'POST_HRMS31E_SEND_MAIL'
export const GET_HRMS31E_SAVE_BUTTON_DISP = 'GET_HRMS31E_SAVE_BUTTON_DISP'
export const SET_HRMS31E_SAVE_BUTTON_DISP = 'SET_HRMS31E_SAVE_BUTTON_DISP'
export const RECEIVED_HRMS31E_DROPDOWNS = 'RECEIVED_HRMS31E_DROPDOWNS'
export const SET_HRMS31E_DROPDOWNS = 'SET_HRMS31E_DROPDOWNS'
export const GET_HRMS31E_DROPDOWNS = 'GET_HRMS31E_DROPDOWNS'



// WEBPACK FOOTER //
// ./src/store/modules/hrms31e/mutation-types.js